// Notes:
// - references: https://monash-esol.atlassian.net/wiki/spaces/UE/pages/130188616/Enrolment+status+Study+Calendar+view
// - 'UNCONFIRMED', 'ACCEPTED' not yet available from api
const COURSE_STATUS = {
  INACTIVE: 'INACTIVE', // not yet enrolled
  INTERMIT: 'INTERMIT', // enrolled but taken intermission
  ENROLLED: 'ENROLLED', // enrolled and in progress
  COMPLETED: 'COMPLETED', // enrolled and completed
  DISCONTIN: 'DISCONTIN', // ended without completion
};

export default COURSE_STATUS;
